import { isEmbeddedFrame } from '@/lib/arcgis-oauth-nav';

/**
 * Deployed builds (Railway TEST / prod-agritour) require Monday board-view iframe embed.
 * Local Vite dev keeps direct URL access for debugging.
 */
export function isAgriTourEntrepreneursMapEmbedRequired(): boolean {
  return !import.meta.env.DEV;
}

export function isAgriTourEntrepreneursMapAllowed(): boolean {
  if (!isAgriTourEntrepreneursMapEmbedRequired()) {
    return true;
  }
  return isEmbeddedFrame();
}
